import { Type } from 'class-transformer';
import { serializeType } from './common';


export class ToDoComment {
  id: number;
  version: number;
  comment: string;
  userFullName: string;
  userId: number;
  todoTaskId: number;
  @Type(serializeType(Date)) displayCreatedOn: Date;
}

export class ToDo {
  subtype: string;
  id: number;
  version: number;
  duedate: string;
  title: string;
  description: string;
  reminder: boolean;
  completed: boolean;
  enableUserToChangeTODOStatus: boolean;
  taskLaneName: string;
  taskLaneId: number;
  vendorId: number;
  customerId: number;
  projectId: number;
  contractId: number;
  projectEstimateId: number;
  sequenceNum: number;
  assignedById: number;
  assignedToId: number;
  assignedToName: string;
  comments?: string;
  @Type(serializeType(ToDoComment)) taskTodoComments: ToDoComment[];
}

export class Container {
  id: number;
  version: number;
  lane: string;
  taskCompletion: boolean;
  entityType: string;
  sequenceNum: number;
  @Type(serializeType(ToDo)) widgets?: Array<ToDo>;
}

export class SimpleLane {
  id: number;
  lane: string;
}